// initial state
const state = {
  all: [],
  groups: [],
  defaultFields: [],
  groupRevision: 0,
  auditlogLoading: false,
  manualEntryResult: {
    revision: 0,
    ok: false,
    error: ''
  },
  count: 0,
  missingReasons: 0,
  toolsLog: 'Loading...',
  emailBounceOverview: {
    total_recent: 0,
    hard_bounces: 0,
    deferred: 0,
    rate_limited: 0,
    alarmable_recent: 0,
    non_alarm_recent: 0,
    blacklist_recent: 0,
    threshold: 10,
    deferred_threshold: 5,
    window_minutes: 15,
    log_read_limit: 5000,
    recent_limit: 250,
    alarm_active: false,
    active_alerts: [],
    by_reason: {},
    by_provider: [],
    recent: []
  },
  emailRoutingRules: {
    default: 'namecheap',
    rules: [],
    updated_at: null
  }
}

// getters
const getters = {
  Auditlog: state => state.all,
  AuditlogGroups: state => state.groups,
  AuditlogDefaultFields: state => state.defaultFields,
  AuditlogGroupRevision: state => state.groupRevision,
  AuditlogLoading: state => state.auditlogLoading,
  AuditlogManualEntryResult: state => state.manualEntryResult,
  LogCount: state => state.count,
  AuditlogMissingReasons: state => state.missingReasons,
  ToolsLog: state => state.toolsLog,
  EmailBounceOverview: state => state.emailBounceOverview,
  EmailRoutingRules: state => state.emailRoutingRules,
}

// actions
const actions = {
  getAuditlog ({ commit }, trades) {
    commit('setAuditlog', trades.data)
    commit('setAuditlogLoading', false)
  },
  startAuditlogLoading ({ commit }) {
    commit('setAuditlogLoading', true)
  },
  createManualAuditLogEntryResult ({ commit }, result) {
    commit('setManualEntryResult', result.data)
  },
  auditLogGroupsChanged ({ commit }) {
    commit('incrementAuditLogGroupRevision')
  },
  getToolslog ({ commit }, trades) {
    commit('setToolslog', trades.data)
  },
  getEmailBounceOverview ({ commit }, payload) {
    commit('setEmailBounceOverview', payload.data)
  },
  getEmailRoutingRules ({ commit }, payload) {
    commit('setEmailRoutingRules', payload.data)
  },
  ClearLog ({ commit }, trades) {
    commit('clearToolslog')
  },
  clearAuditlog ({ commit }) {
    commit('clearAuditlog')
  }
}

// mutations
const mutations = {
  setAuditlog (state, log) {
    state.all = log.entries
    state.groups = log.groups || []
    state.defaultFields = log.default_fields || []
    state.missingReasons = log.missing_reasons || 0
    if (log.count_included) {
      state.count = log.count || 0
    }
  },
  setAuditlogLoading (state, loading) {
    state.auditlogLoading = loading
  },
  setManualEntryResult (state, result) {
    state.manualEntryResult = {
      revision: state.manualEntryResult.revision + 1,
      ok: Boolean(result && result.ok),
      error: result && result.error ? result.error : ''
    }
  },
  clearAuditlog (state) {
    state.all = []
    state.groups = []
    state.defaultFields = []
  },
  incrementAuditLogGroupRevision (state) {
    state.groupRevision++
  },
  clearToolslog (state) {
    state.toolsLog = 'Loading...'
  },
  setToolslog (state, log) {
    state.toolsLog = log
  },
  setEmailBounceOverview (state, overview) {
    state.emailBounceOverview = overview
  },
  setEmailRoutingRules (state, payload) {
    state.emailRoutingRules = payload
  }

}

export default {
  state,
  getters,
  actions,
  mutations
}
